import { createContext, Component } from 'react';
import { callIfPossible } from '../utils/functions';
import { jsx as _jsx } from "react/jsx-runtime";
const {
  Consumer,
  Provider
} = /*#__PURE__*/createContext({});
export { Consumer, Provider };
class Registration extends Component {
  componentDidMount() {
    callIfPossible(this.props.register);
  }
  componentWillUnmount() {
    callIfPossible(this.props.unregister);
  }
  render() {
    return null;
  }
}
export function RegistersPanelHeader() {
  return /*#__PURE__*/_jsx(Consumer, {
    children: ({
      registerPanelHeader,
      unregisterPanelHeader
    }) => /*#__PURE__*/_jsx(Registration, {
      register: registerPanelHeader,
      unregister: unregisterPanelHeader
    })
  });
}
export function RegistersPanelBody() {
  return /*#__PURE__*/_jsx(Consumer, {
    children: ({
      registerPanelBody,
      unregisterPanelBody
    }) => /*#__PURE__*/_jsx(Registration, {
      register: registerPanelBody,
      unregister: unregisterPanelBody
    })
  });
}